import Vue from "vue";

Vue.filter("simpleDate", function (value) {
  if (!value) return "Нет даты";
  const d = new Date(value);
  return d.toLocaleDateString("ru");
});

Vue.filter("statusOrder", function (value) {
  // Статусы заявки
  if (!value) return "Без статуса";
  let status = {
    1: "Новая",
    2: "В работе",
    3: "Подтверждена",
    4: "Резерв",
    5: "Отклонена",
    6: "Закрыта",
    7: "Отменена",
  };
  return status[value];
});

Vue.filter("classOrder", function (value) {
  // Оформление статуса заяки
  if (!value) return "";
  let class_ = {
    1: "turquoise turquoise--filled",
    2: "blue blue--filled",
    3: "green green--filled",
    4: "orange orange--filled",
    5: "carrot carrot--filled",
    6: "green green--filled",
    7: "carrot carrot--filled",
    8: "green green--filled",
  };
  return class_[value];
});
Vue.filter("classNotification", function (value) {
  // Оформление статуса заяки
  if (!value) return "";
  let class_ = {
    1: "turquoise",
    2: "orange",
    3: "red",
  };
  return class_[value];
});
